import { defineMessages } from 'react-intl';

export const disclaimerMessages = defineMessages({
  eligibilityCheck: {
    id: 'NoCardEntry.ComposeTeam.eligibilityCheck',
    defaultMessage:
      'Please check the eligibility requirements for the Sorare Pro 24/25 competition you wish to enter',
  },
  leaderboardSelection: {
    id: 'NoCardEntry.ComposeTeam.disclaimer',
    defaultMessage:
      'Once you have selected all your players, you will be able to select the competition in which your lineup will enter, subject to the eligibility criteria.',
  },
  captain: {
    id: 'NoCardEntry.ComposeTeam.captainDisclaimer',
    defaultMessage:
      'If there is a captain bonus in the competition your team will be submitted into, Sorare will select as captain the player with the highest player score based on the last Game Week.',
  },
});
